import type { ComponentType } from "react";

import { ArticleRenderContextProvider } from "./contexts";

export function withArticleRenderContext<Props extends object>(Component: ComponentType<Props>) {
  const WrappedComponent = (props: Props) => (
    <ArticleRenderContextProvider>
      <Component {...props} />
    </ArticleRenderContextProvider>
  );
  return WrappedComponent;
}
